<app-layout [enableTopGap]="true">
  <section class="quiz-page" [class.q-intro]="intro">
    <div class="quiz-shell wide">
      <header class="quiz-list-header">
        <h1>{{ "quizes.header" | translate }}</h1>
        <p class="quiz-list-rules">
          <span><i class="fas fa-list-ol" aria-hidden="true"></i> {{ "quizes.rules.questions" | translate: { count: questionCount } }}</span>
          <span><i class="fas fa-clock" aria-hidden="true"></i> {{ "quizes.rules.time" | translate: { minutes: examMinutes } }}</span>
          <span><i class="fas fa-check-double" aria-hidden="true"></i> {{ "quizes.rules.mistakes" | translate: { count: maxMistakes } }}</span>
        </p>
      </header>

      <div class="quiz-list-controls quiz-bank-controls">
        <nav class="quiz-segment" [attr.aria-label]="'quizes.category.label' | translate">
          <a *ngFor="let category of categories" [routerLink]="categoryLink(category)"
            [class.active]="isCategory(category)" [attr.aria-current]="isCategory(category) ? 'page' : null">
            {{ "quizes.category." + category | translate }}
          </a>
        </nav>
        <label class="quiz-language-select">
          <i class="fas fa-language" aria-hidden="true"></i>
          <span>{{ "quizes.questionLanguage" | translate }}</span>
          <select (change)="setQuestionLanguage($any($event.target).value)">
            <option *ngFor="let language of questionLanguages" [value]="language.code"
              [selected]="language.code === questionsLang">{{ language.label }}</option>
          </select>
        </label>
      </div>
      <p class="quiz-mode-description">{{ "quizes.edition.v2Description" | translate }}</p>

      <p *ngIf="isFallback" class="quiz-notice" role="note">
        <i class="fas fa-language" aria-hidden="true"></i>
        {{ "quizes.languageFallback" | translate }}
      </p>

      <div class="quiz-list-controls">
        <div class="quiz-segment" role="radiogroup" [attr.aria-label]="'quizes.modeLabel' | translate"
          [style.--seg]="mode === 'exam' ? 0 : 1">
          <button type="button" role="radio" [attr.aria-checked]="mode === 'exam'" [class.active]="mode === 'exam'"
            (click)="setMode('exam')">
            <i class="fas fa-stopwatch" aria-hidden="true"></i> {{ "quizes.mode.exam" | translate }}
          </button>
          <button type="button" role="radio" [attr.aria-checked]="mode === 'practice'" [class.active]="mode === 'practice'"
            (click)="setMode('practice')">
            <i class="fas fa-graduation-cap" aria-hidden="true"></i> {{ "quizes.mode.practice" | translate }}
          </button>
        </div>
        <button type="button" class="quiz-btn" (click)="startRandom()" [disabled]="!quizzes.length">
          <i class="fas fa-random" aria-hidden="true"></i> {{ "quizes.random" | translate }}
        </button>
      </div>
      <p class="quiz-mode-description">{{ "quizes.modeDescription." + mode | translate }}</p>

      <div *ngIf="loading" class="quiz-state" role="status">
        <i class="fas fa-circle-notch fa-spin" aria-hidden="true"></i>
        <span>{{ "quiz.loading" | translate }}</span>
      </div>

      <ng-container *ngIf="!loading">
        <div *ngIf="attemptedCount" class="quiz-list-stats">
          <div class="quiz-list-stats-bar" aria-hidden="true">
            <span [style.width.%]="(passedCount / quizzes.length) * 100"></span>
          </div>
          <span>{{ "quizes.stats" | translate: { passed: passedCount, attempted: attemptedCount, total: quizzes.length } }}</span>
        </div>

        <ul class="quiz-grid">
          <li *ngFor="let quiz of quizzes; trackBy: trackById" appReveal="rise" revealBatch [revealDistance]="16"
            [revealDuration]="0.45" revealStart="top 95%">
            <a class="quiz-card-link" [routerLink]="[quizBasePath, quiz.id]" [queryParams]="queryParams()"
              [class.passed]="lastResult(quiz)?.passed === true"
              [class.failed]="lastResult(quiz)?.passed === false">
              <span class="quiz-card-number">{{ quiz.id }}</span>
              <span class="quiz-card-body">
                <span class="quiz-card-title">{{ "quizes.ticket" | translate: { number: quiz.id } }}</span>
                <span class="quiz-card-status" *ngIf="lastResult(quiz) as last; else notStarted">
                  <i class="fas" [ngClass]="last.passed ? 'fa-check-circle' : 'fa-redo'" aria-hidden="true"></i>
                  {{ (last.passed ? "quizes.passed" : "quizes.failed") | translate: { score: last.score, total: last.totalQuestions } }}
                </span>
                <ng-template #notStarted>
                  <span class="quiz-card-status">{{ "quizes.notStarted" | translate }}</span>
                </ng-template>
              </span>
              <i class="fas fa-chevron-right quiz-card-arrow" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </ng-container>
    </div>
  </section>
</app-layout>
